import React from "react";
import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { testimonials } from "../data/menu";

const Testimonials = () => {
  return (
    <section
      id="depoimentos"
      className="relative py-24 sm:py-32 bg-[var(--sn-bg)] overflow-hidden"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="h-px w-10 bg-[var(--sn-gold)]" />
            <span className="text-[var(--sn-gold)] tracking-[0.3em] text-xs uppercase">
              Quem Prova, Recomenda
            </span>
            <span className="h-px w-10 bg-[var(--sn-gold)]" />
          </div>
          <h2
            className="font-display text-4xl sm:text-5xl lg:text-6xl text-[var(--sn-cream)] mb-4"
            data-testid="testimonials-headline"
          >
            Histórias servidas{" "}
            <span className="italic gold-text">à nossa mesa</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="relative bg-[var(--sn-bg-surface)]/50 border border-[var(--sn-border)] p-8 sm:p-10 hover:border-[var(--sn-gold)] transition-all duration-500 sn-frame"
              data-testid={`testimonial-card-${i}`}
            >
              <Quote className="absolute top-6 right-6 w-8 h-8 text-[var(--sn-gold)]/30" />

              <div className="flex gap-1 mb-5">
                {Array.from({ length: t.rating }).map((_, k) => (
                  <Star
                    key={k}
                    className="w-4 h-4 fill-[var(--sn-gold)] text-[var(--sn-gold)]"
                  />
                ))}
              </div>

              <p className="text-[var(--sn-cream)] text-lg leading-relaxed font-serif-alt italic mb-8">
                &ldquo;{t.text}&rdquo;
              </p>

              <div className="flex items-center gap-4 border-t border-[var(--sn-border)] pt-5">
                <div className="w-11 h-11 rounded-full bg-[var(--sn-gold)]/15 border border-[var(--sn-gold)] flex items-center justify-center font-display text-[var(--sn-gold)]">
                  {t.name
                    .split(" ")
                    .map((n) => n[0])
                    .slice(0, 2)
                    .join("")}
                </div>
                <div>
                  <p className="font-display text-[var(--sn-cream)] text-lg leading-none">
                    {t.name}
                  </p>
                  <p className="text-[var(--sn-gold)]/80 text-xs mt-1 tracking-wide">
                    {t.role}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
